module.exports = __webpack_public_path__ + "static/media/effect_01.3252f113.png";